import * as types from 'store/modules/hrms76x/mutation-types'
import hrms76x from 'api/hrms76x'
import swal from 'sweetalert'
import hrms76xLabels from 'assets/labels/hrms76x'
import { hrms76xColumns } from 'assets/columns/hrms76x'
import configLabel from 'src/../config/label'

export default {
  state: {
    indexDisp: true,
    labels: hrms76xLabels,
    columns: hrms76xColumns(),
    index: {
      total: 0,
      rows: []
    },
    response: {
      status: '',
      message: ''
    }
  },
  getters: {
    [types.GET_HRMS76X_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_HRMS76X_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRMS76X_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRMS76X_INDEX] (state) {
      return state.index
    }
  },
  mutations: {
    [types.SET_HRMS76X_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_HRMS76X_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
      }
    },
    [types.SET_HRMS76X_LABELS] (state, labels) {
      state.labels = labels
    },
    [types.SET_HRMS76X_INDEX] (state, data) {
      state.index = data
    }
  },
  actions: {
    [types.TOGGLE_HRMS76X_PAGE] ({ commit }, page) {
      let indexDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
      }
      commit(types.SET_HRMS76X_INDEX_DISP, indexDisp)
    },
    [types.RECEIVED_HRMS76X_COLUMNS_LABELS] ({ commit }) {
      hrms76x.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS76X_COLUMNS, data.labels)
          commit(types.SET_HRMS76X_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS76X_INDEX] ({ commit }, searchParams) {
      hrms76x.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS76X_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
          let objData = {
            total: 0,
            rows: []
          }
          commit(types.SET_HRMS76X_INDEX, objData)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hrms76x/index.js